import page from 'page'
import axios from 'axios'

const BACKEND_URL = process.env.REACT_APP_HOST + 'api/'

export const API_CONST = 'api/CALL'

export default store => next => async ({ type, payload = {}, meta = {} }) => {
  let resultStatus = null

  if (type === API_CONST) {
    let result = {}
    let { method = 'get', params = {}, url, options = {}, file, noRedirect = false, redirectWindow = false } = payload
    let [ startAction, successAction, errorAction ] = payload.actions
    method = method.toLowerCase()

    let prefix = BACKEND_URL
    options.withCredentials = true
    options.auth = { username: 'test', password: 'test' }

    if (!options.headers) options.headers = {}
    options.headers['X-Country'] = window.localStorage.getItem('countryId') || null

    if (file) {
      let tmpData = new FormData() // eslint-disable-line
      tmpData.append('files', file)
      Object.values(params).map(key => { tmpData.append(key, params[key]) }) // eslint-disable-line
      params = tmpData
    }

    try {
      if (startAction) store.dispatch({ type: startAction, payoad: params, meta })
      if (method === 'get') result = await axios[method](prefix + url, { ...options, params })
      else result = await axios[method](prefix + url, params, options)
      resultStatus = result.data.status || result.status
      if (resultStatus !== 200) {
        if (errorAction) next({ type: errorAction, payload: result.data, meta })
      } else if (successAction) next({ type: successAction, payload: result.data.data, meta })
    } catch (e) {
      resultStatus = e.response ? e.response.status : 500
      if (resultStatus === 301 && e.response && !noRedirect) {
        if (redirectWindow) window.location = e.response.data.error
        else page(e.response.data.error)
      }
      if (errorAction) next({ type: errorAction, payload: { status: resultStatus, message: e }, meta })
    }
  } else next({ type, payload, meta })

  return resultStatus || type
}



// WEBPACK FOOTER //
// ./src/store/middlewares/api.js